var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.7812C8.51796 11.7812 9.49412 11.6807 10.3988 11.4963C11.5288 11.2659 12.0938 11.1507 12.6094 10.4878C13.125 9.82493 13.125 9.06398 13.125 7.54197V6.45803C13.125 4.93604 13.125 4.17505 12.6094 3.51215C12.0938 2.84924 11.5288 2.73407 10.3988 2.50372C9.49412 2.31931 8.51796 2.21875 7.5 2.21875C6.48204 2.21875 5.50588 2.31931 4.60119 2.50372C3.47118 2.73407 2.90618 2.84924 2.39059 3.51215C1.875 4.17505 1.875 4.93604 1.875 6.45803V7.54197C1.875 9.06398 1.875 9.82493 2.39059 10.4878C2.90618 11.1507 3.47118 11.2659 4.60119 11.4963C5.50588 11.6807 6.48204 11.7812 7.5 11.7812Z",
    stroke: "#007AFF",
    strokeWidth: 0.84375
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72868 7.176C9.64521 7.51677 9.20106 7.76151 8.31276 8.25106C7.34655 8.78341 6.86348 9.04964 6.4722 8.94709C6.33968 8.91233 6.21761 8.85124 6.11512 8.76839C5.8125 8.52376 5.8125 8.01582 5.8125 7C5.8125 5.98418 5.8125 5.47625 6.11512 5.2316C6.21761 5.14873 6.33968 5.08766 6.4722 5.05293C6.86348 4.95037 7.34655 5.21656 8.31276 5.74896C9.20106 6.23849 9.64521 6.48323 9.72868 6.82399C9.75709 6.93998 9.75709 7.06002 9.72868 7.176Z",
    stroke: "#007AFF",
    strokeWidth: 0.84375,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.5e635b09248ebc8b7e81b235df22a5eb.svg";
export { ForwardRef as ReactComponent };